const PropTypes = require('prop-types');
const React = require('react');
const union = require('lodash/array/union');
const { formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { mergeOrderAndId, uniqContractFilter } = require('utilities/APIParsingHelper');
const { PLURAL_CHARACTER } = require('constants/index');
const GlobalPositionFinancialCard = require('components/globalPosition/globalPositionFinancialCard/globalPositionFinancialCard');

class GlobalPositionCreditCard extends React.Component {

    getCards() {
        const { immCards } = this.props;
        const immCreditCards = this.mergeCreditCardsByOrderAndId(immCards);

        if(__CONTACT_CENTER__) {
            return this.prepareCardsForCC(immCreditCards);
        }else {
            return this.prepareCardsForPrivate(immCreditCards);
        }
    }

    mergeCreditCardsByOrderAndId(immCards) {
        return mergeOrderAndId(immCards.get('credit').get('byOrder'), immCards.get('byId'));
    }

    prepareCardsForCC(immCreditCards) {
        return immCreditCards.map((immCard) => this.mapCards(immCard)).toJS();
    }

    prepareCardsForPrivate(immCreditCards) {
        const validCards = immCard => {
            return immCard.get('filters').get('valid') && immCard.get('visibleinPG');
        };

        return immCreditCards.filter(validCards).map((immCard) => this.mapCards(immCard)).toJS();
    }

    mapCards(immCard) {
        return {
            title: immCard.get('alias').get('current'),
            titleSmall: getLastNChars(immCard.get('number'), 4),
            subtitleAmount: immCard.get('availableBalance').get('amount'),
            subtitleCurrency: immCard.get('availableBalance').get('currency'),
            amount:  immCard.get('balanceDrawn').get('amount'),
            currency: immCard.get('balanceDrawn').get('currency'),
            link: `/myprofile/cards/${immCard.get('cardId')}/movements`
        }
    }

    getTotalForCC(immCards) {
        const immCreditCards = this.mergeCreditCardsByOrderAndId(immCards);
        let amount = 0;
        let currency;

        immCreditCards.toJS().filter(card=>card.active===true).forEach(filteredCard=> {
            amount = amount+ filteredCard.balanceDrawn.amount;
            currency = filteredCard.balanceDrawn.currency;
        });

        return [{
            amount: amount,
            currency: currency,
            legend: formatText('myGlobalPosition-disposed')
        }];
    }

    getCurrencyAvailableForCC(immCards) {
        const immCreditCards = this.mergeCreditCardsByOrderAndId(immCards);
        let amount = 0;
        let currency;

        uniqContractFilter(immCreditCards.toJS()).filter(card => !!card.active).forEach(filteredCard => {
            amount = amount + filteredCard.availableBalance.amount;
            currency = filteredCard.availableBalance.currency;
        });

        return [{
            amount: amount,
            currency: currency,
            legend: formatText('myGlobalPosition-available')
        }];
    }

    getAvailableForPrivate(immCards) {
        return immCards.get('credit').get('availableBalanceForPG').map(currencyContent => {
            return {
                currency: currencyContent.get('currency'),
                amount: currencyContent.get('amount'),
                legend: formatText('myGlobalPosition-available')
            }
        }).toJS();
    }

    getTotalForPrivate(immCards) {
        return immCards.get('credit').get('balanceDrawnForPG').map(currencyContent => {
            return {
                currency: currencyContent.get('currency'),
                amount: currencyContent.get('amount'),
                legend: formatText('myGlobalPosition-disposed')
            }
        }).toJS();
    }

    getCurrencyDetail() {
        const { immCards } = this.props;
        let available = 0;
        let total = 0;

        if(__CONTACT_CENTER__) {
            total= this.getTotalForCC(immCards);
            available = this.getCurrencyAvailableForCC(immCards);
        } else {
            available = this.getAvailableForPrivate(immCards);
            total = this.getTotalForPrivate(immCards);
        }

        return union(available, total);
    }

    render() {
        const {immCards} = this.props;
        const excludedItems = immCards.get('credit') ? immCards.get('credit').get('excludedCards') : 0;
        const pluralPostfix = excludedItems !== 1 ? PLURAL_CHARACTER : '';
        const subtitle = excludedItems > 0 ? formatText('myGlobalPosition-excludedCards', [excludedItems, pluralPostfix, pluralPostfix]) : '';
        const currencyDetails = this.getCurrencyDetail();
        const creditCards = this.getCards();

        return (
            <GlobalPositionFinancialCard
                id={this.props.id}
                icon="rebrand-credit-card"
                amount={creditCards.length}
                cards={creditCards}
                currencyDetails={currencyDetails}
                showMoreText={formatText('myGlobalPosition-creditCardShowMore')}
                showMoreLink="/myprofile/cards"
                title={formatText('myGlobalPosition-creditCards')}
                subtitle={subtitle}
                expanded={this.props.expanded}
                hasExcludedItems={excludedItems > 0}
                allItemsExcluded={excludedItems > 0 && !creditCards.length}
                emptyStateMessage={formatText('myGlobalPosition-allCreditCardsExcluded')}
                titleLink="/myprofile/cards"
                isOnPG={true}
            />
        );
    }
}





GlobalPositionCreditCard.propTypes = {
    immCards: PropTypes.object.isRequired,
    id: PropTypes.string,
    expanded: PropTypes.bool
};

module.exports = GlobalPositionCreditCard;